import { getDataExport, getFilteredData } from '~/api/data';

export interface Data {
  version: string;
  crf: string;
  nfr: string;
  category: string;
  classification: string;
  undergrupp: string;
  measure: string;
  gas: string;
  unit: string;
  source: string;
  method: string;
  target: string;
  option: string;
  type: string;
  dataValues: { emissionYear: string; value: string, comment: string, nk_explanation: string, allocation_by_ipcc: string, allocation_by_party: string}[];
}

class DataServiceClass {
  public getFilteredData(filter: object, controller: AbortController): Promise<Data[]> {
    return getFilteredData(filter, controller);
  }

  public getDataExport(filter: object) {
      return getDataExport(filter);
  }
}
export const DataService = new DataServiceClass();
